import { useParams } from 'react-router-dom';
import { CreateUpdateProjectForm } from 'src/components';

export const CreateUpdateProject = () => {
    const { id } = useParams<{ id: string }>();
    return <CreateUpdateProjectForm projectId={id} />;
};
